export default "__VITE_ASSET__9wDTMdr___"